<template>
  <div >
    <md-card class="side">
      <md-card-header>
        <div class="md-title">{{server.name}}</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">

          <div class="md-layout-item">
      
            <md-field>
              <label>Nombre</label>
              <md-input v-model="server.name"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
      
            <md-field>
              <label>Instancia</label>
              <md-input v-model="server.instance"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
      
            <md-button @click="deactivate" v-if="server.isActive" class="md-success">Activo</md-button>
            <md-button @click="deactivate" v-else class="md-danger">Inactivo</md-button>
          </div>

        </div>

        <div class="md-layout">
          <div class="md-layout-item">

          <md-field>
            <label>Ip privada</label>
            <md-input v-model="server.ip.private"></md-input>
          
            <md-button   :data-clipboard-text="server.ip.private" class="md-round clipboard" title="copiar ip private" >              
              <md-icon >file_copy</md-icon> 
            </md-button>
          </md-field>
          </div>
          <div class="md-layout-item">

          <md-field>
            <label>Ip pública</label>
            <md-input v-model="server.ip.public"></md-input>
          
            <md-button   :data-clipboard-text="server.ip.public" class="md-round clipboard" title="copiar ip pública" >              
              <md-icon >file_copy</md-icon> 
            </md-button>
          </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-50">

          <md-field>
            <label>Memoria ram</label>
            <md-input v-model="server.specs.ram"></md-input>
          
          </md-field>
          </div>
          <div class="md-layout-item md-size-50">

          <md-field>
            <label>Módelo cpu</label>
            <md-input v-model="server.specs.cpu"></md-input>
          </md-field>

          </div>
          <div class="md-layout-item md-size-50">
          <md-field>
            <label>Nucleos del cpu</label>
            <md-input v-model="server.specs.cores"></md-input>
          
          </md-field>
          </div>
          <div class="md-layout-item md-size-50">

          <md-field>
            <label>Sistema operativo</label>
            <md-input v-model="server.specs.os"></md-input>
          </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item">

          <md-field>
            <label>Nombre del proveedor</label>
            <md-input v-model="server.provider.name"></md-input>
          </md-field>
          </div>
          <div class="md-layout-item">

          <md-field>
            <label>Url del proveedor</label>
            <md-input v-model="server.provider.url"></md-input>
          </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item">

          <md-field>
            <label>Usuario</label>
            <md-input v-model="server.user"></md-input>
            <md-button   :data-clipboard-text="server.user" class="md-round clipboard" title="copiar usuario" >              
              <md-icon >file_copy</md-icon> 
            </md-button>
          </md-field>
          </div>
          <div class="md-layout-item">

          <md-field>
            <label>Contraseña</label>
            <md-input v-model="server.password"></md-input>
            <md-button   :data-clipboard-text="server.password" class="md-round clipboard" title="copiar password" >              
              <md-icon >file_copy</md-icon> 
            </md-button>
          </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div v-for=" client in server.clients" class="md-layout-item" :key="client._id">

          <md-field>
            <label>{{client.name}}</label>
          </md-field>
          </div>
        </div>
   
      </md-card-content>

      <md-card-actions>
        <md-button @click="set">Guardar</md-button>
      </md-card-actions>
    </md-card>


  </div>
</template>
<script>
import axios from "axios";
// import api from "../../../lib/api.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ServerComponent",
  components: {},
  data() {
    return {
      servers: [],
      server: {
        ip: {},
        specs: {},
        provider: {}
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    if (typeof id !== "undefined") {
      this.get(id)
        .then(res => {
          this.server = res;
        })
        .catch(err => {
          console.warn(err);
        });
    }
  },
  computed: {
    // ...mapGetters({
    //   item: "servers/server"
    // })
  },
  methods: {
    ...mapActions({
      get: "servers/getOne",
      save: "servers/save",
      create: "servers/create"
    }),
    set() {
      if (this.server._id) {
        this.save(this.server).then(res => {
          this.$notify({
            message: "Servidor guardado con exito",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
      } else {
        this.create(this.server).then(res => {
          this.$notify({
            message: "Servidor guardado con exito",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
      }
    },
    deactivate() {
      this.server.isActive = !this.server.isActive;
    }
  }
};
</script>
<style scoped>
.md-card.side {
  display: inline-block;
}
</style>
